module.exports = __webpack_public_path__ + "img/servicepro_small.975b1260.png";